import makeElementRootPosition from './make-element-root-position';
import isElementRequireRootPosition from '../verifiers/is-element-require-root-position';
import { IMAGE_TAG } from '../constants/editable-elements';
import { IMAGE_SELECTOR } from '../../hdrm/constants/image-selector';

const handleNestedMediaContent = (rootElement) => {
  const mediaElements = Array.from(rootElement.querySelectorAll(IMAGE_TAG)).map((el) => {
    const closestImageContainer = el.closest(IMAGE_SELECTOR);
    if (closestImageContainer) return closestImageContainer;
    return el;
  });

  mediaElements
    .filter((el) => isElementRequireRootPosition(el, rootElement))
    .forEach((el) => makeElementRootPosition(el, rootElement));
};

export default handleNestedMediaContent;
